import { useHotkeys } from "react-hotkeys-hook";
import { ReactNode } from "react";
import { create } from "zustand";
import useAlert from "@/shared/hooks/useAlert";
import CustomModal from '@/widget/modal/ui/Modal';

export interface Alert {
  title?: string;
  message: any;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  isHTML?:boolean;
  showCancelButton?: boolean;
}

interface ViewProps {
  alert: Alert;
}

interface AlertState {
  alert: Alert | null;
  setAlert: (newAlert: Alert) => void;
  clearAlert: () => void;
}

export const useAlertStore = create<AlertState>((set) => ({
  alert: null,
  setAlert: (newAlert) => set({ alert: newAlert }),
  clearAlert: () => set({ alert: null }),
}));

const View = ({ alert }: ViewProps) => {
  const { removeAlert } = useAlert();
  const { title, message, onCancel, onConfirm, confirmLabel, cancelLabel , isHTML } =
    alert;

  const handleCancel = () => {
    if (onCancel) onCancel();
    removeAlert();
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    removeAlert();
  };

  useHotkeys("escape", () => removeAlert());
  useHotkeys("enter", () => handleConfirm());

  return (
    <CustomModal isOpen={true} onClose={removeAlert}>
      {title && <h1 className="modal-title">{title}</h1>}
      {/*<p className="modal-message">{message}</p>*/}

      {isHTML ? (
        <p className="modal-message" dangerouslySetInnerHTML={{ __html: message }} />
      ) : (
        <p className="modal-message">{message}</p>
      )}

      <div className={`modal-bottom-button ${cancelLabel ? "cancel" : ""}`}>
        {cancelLabel && (
          <button
            type={"button"}
            onClick={handleCancel}
          >
            {cancelLabel}
          </button>
        )}
        <button
          type="button"
          onClick={handleConfirm}
        >
          {confirmLabel || "확인"}
        </button>
      </div>
    </CustomModal>
  );
};

export default View;
